import { ReactNode } from "react";

interface SectionProps {
  children: ReactNode;
  id?: string;
  className?: string;
  background?: "white" | "gray" | "gradient" | "mesh" | "dots";
  padding?: "sm" | "md" | "lg" | "xl";
}

export default function Section({
  children,
  id,
  className = "",
  background = "white",
  padding = "lg",
}: SectionProps) {
  const backgroundClasses = {
    white: "bg-white dark:bg-navy-900",
    gray: "bg-gray-50 dark:bg-navy-950",
    gradient:
      "bg-gradient-to-br from-primary-50 via-white to-sky-50/30 dark:from-navy-900 dark:via-gray-900 dark:to-primary-950/20",
    mesh: "bg-white dark:bg-navy-900 bg-mesh relative",
    dots: "bg-white dark:bg-navy-900 bg-dots relative",
  };

  const paddingClasses = {
    sm: "py-12",
    md: "py-16",
    lg: "py-20",
    xl: "py-24",
  };

  const classes = `${backgroundClasses[background]} ${paddingClasses[padding]} ${className}`;

  return (
    <section id={id} className={classes}>
      <div className="section-container relative z-10">{children}</div>
    </section>
  );
}
